import React from "react";
import { object, shape, func, array } from "prop-types";
import get from "lodash/get";
import { LoadMoreCollectionStories, LazyLoadImages, LazyCollection } from "@quintype/components";
import ThreeStoriesWithSubscribeMail from "../../rows/three-stories-with-subscribe-mail";
import { getCollectionTemplate } from "../../get-collection-template";
import HorizontalStoryCardList from "../../molecules/horizontal-story-card-list";
import VerticleStoryCardList from "../../molecules/verticle-story-card-list";
import getStoriesByCollection from "../../../utils";
import { LoadMoreButton } from "../../atoms/load-more-button";

import "./general-section.m.css";

const GeneralSectionPage = props => {
  const stories = getStoriesByCollection(props.data.collection).slice(0, 19) || [];
  const totalCount = get(props, ["data", "collectionstories", "collection", "total-count"], "");
  const isCollectionPresent = get(props, ["data", "collection", "items"], []).filter(
    collection => collection.type === "collection"
  );
  const limit = isCollectionPresent && isCollectionPresent[0] ? "3" : "4";

  if (stories.length < 1 && isCollectionPresent.length < 1) {
    return <div styleName="not-found">Stories not found...</div>;
  }

  const storiesTemplate = ({ onLoadMore, stories }) => {
    return (
      <div styleName="story-wrapper">
        <div className="desktop-only">
          <HorizontalStoryCardList stories={stories.slice(limit, stories.length)} />
        </div>
        <div className="mobile-only">
          <VerticleStoryCardList stories={stories.slice(limit, stories.length)} />
        </div>
        {totalCount !== stories.length && <LoadMoreButton onClick={onLoadMore} />}
      </div>
    );
  };
  return (
    <React.Fragment>
      {stories.length > 0 && <ThreeStoriesWithSubscribeMail limit={limit} {...props} stories={stories} />}
      {isCollectionPresent.length > 0 && (
        <div styleName="remove-infinite-data-margin">
          <LazyLoadImages>
            <LazyCollection
              collection={props.data.collection}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={2}
            />
          </LazyLoadImages>
        </div>
      )}
      <div styleName="bottom-fold">
        <LoadMoreCollectionStories
          template={storiesTemplate}
          data={{ stories: stories }}
          collectionSlug={props.data.collection.slug}
          numStoriesToLoad={10}
          params={{ "item-type": "story" }}
        />
      </div>
    </React.Fragment>
  );
};

GeneralSectionPage.propTypes = {
  data: shape({
    collection: object
  }),
  onLoadMore: func,
  stories: array
};

export default GeneralSectionPage;
